import React, { useContext } from "react";

import { DataContext } from "../../../../../../providers/ElectricityDataProvider";
import CalculatorProducts from "../../../../../shared/CalculatorProducts";
import Container from "../../../../../shared/Container";
import ElectricityProduct from "./ElectricityProduct";

const ElectricityCalculatorResult = () => {
    const dataContext = useContext(DataContext);
    const { consumption, result, loading, productChoice } = dataContext.data;
    const { setProductChoice } = dataContext.actions;

    const res = Object.values(result);

    return (
        <Container>
            <div>
                {loading && <div>Preise werden ermittelt</div>}
                {result && (
                    <React.Fragment>
                        <CalculatorProducts
                            products={res}
                            activeIndex={productChoice}
                            onIndexChange={setProductChoice}
                            forceMobileView
                        />
                        <ElectricityProduct
                            consumption={consumption}
                            product={res[productChoice]}
                        />
                    </React.Fragment>
                )}
            </div>
        </Container>
    );
};

export default ElectricityCalculatorResult;
